import './Mc.css';
const MovieComponent = (props) => {
  const { Title, Year, imdbID, Type, Poster } = props.movie;
    return (
      <div className="MovieContainer" 
        onClick={() => {
        props.onMovieSelect(imdbID);
        window.scrollTo({ top: 0, behavior: "smooth" });
      }}>
        <img className="CoverImage" src={Poster}/>
        <span className="MovieTitle">{Title}</span>
        <div className="InfoCol">
            <span className="info">Year : {Year}</span>
            <span className="info">Type : {Type}</span>
        </div>
      </div>

    );
  };
  
  export default MovieComponent;